import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.string.trim-left";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.trim";
import _construct from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.starts-with";
import _slicedToArray from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import useEventCallback from '@restart/hooks/useEventCallback';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { decode } from 'sourcemap-codec';
import transpile, { removeImports } from './transpile';
var prettierComment = /(\{\s*\/\*\s+prettier-ignore\s+\*\/\s*\})|(\/\/\s+prettier-ignore)/gim;
var hooks = {};
Object.entries(React).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  if (key.startsWith('use')) hooks[key] = value;
});
export var Context = React.createContext({});

var getRequire = function getRequire(imports) {
  return function require(request) {
    if (!imports) throw new Error('no imports');
    if (!(request in imports)) throw new Error("Module not found: ".concat(request));
    return imports[request];
  };
};

var wrapAsComponent = function wrapAsComponent(ctx) {
  ctx.prepend('return React.createElement(function StateContainer() {\n');
  ctx.append('\n})');
};

function handleError(err, result, fn) {
  var _result$map, _decoded$line;

  var fnStr = fn.toString(); // account for the function chrome lines

  var offset = fnStr.slice(0, fnStr.indexOf('{')).split(/\n/).length;
  var pos;

  if ('line' in err) {
    pos = {
      line: err.line,
      column: err.column
    };
  } else if ('lineNumber' in err) {
    pos = {
      line: err.lineNumber - 1,
      column: err.columnNumber - 1
    };
  } else {
    var _err$stack;

    var _ref3 = (_err$stack = err.stack) === null || _err$stack === void 0 ? void 0 : _err$stack.match(/at eval.+<anonymous>:(\d+):(\d+)/m),
        _ref4 = _slicedToArray(_ref3, 3),
        _line = _ref4[1],
        col = _ref4[2];

    pos = {
      line: +_line - 1,
      column: +col - 1
    };
  }

  if (!pos) return err;
  var decoded = decode((_result$map = result.map) === null || _result$map === void 0 ? void 0 : _result$map.mappings);
  var line = pos.line - offset;
  var mapping = (_decoded$line = decoded[line]) === null || _decoded$line === void 0 ? void 0 : _decoded$line.find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
        col = _ref6[0];

    return col === pos.column;
  });

  if (mapping) {
    err.location = {
      line: mapping[2],
      column: mapping[3]
    };
  }

  return err;
}

function codeToComponent(code, scope) {
  var renderAsComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return new Promise(function (resolve, reject) {
    var isInline = !code.includes('render(');

    if (renderAsComponent && !isInline) {
      throw new Error('Code using `render()` cannot use top level hooks. Either provide your own stateful component, or return a jsx element directly.');
    }

    var result = transpile(code, {
      inline: isInline,
      wrapper: renderAsComponent ? wrapAsComponent : undefined
    });

    var render = function render(element) {
      if (element === undefined) {
        reject(new SyntaxError('`render()` was called without a JSX element'));
        return;
      }

      resolve(element);
    }; // DU NA NA NAAAH


    var finalScope = _objectSpread(_objectSpread({}, hooks), scope);

    var args = ['React', 'render'].concat(Object.keys(finalScope));
    var values = [React, render].concat(Object.values(finalScope));
    var body = result.code; // eslint-disable-next-line no-new-func

    var fn = _construct(Function, _toConsumableArray(args).concat([body]));

    var element;

    try {
      element = fn.apply(void 0, _toConsumableArray(values));
    } catch (err) {
      reject(handleError(err, result, fn));
      return;
    }

    if (!isInline) return;

    if (element === undefined) {
      reject(new SyntaxError('The code did not return a JSX element'));
      return;
    }

    resolve(element);
  });
}

export function useLiveContext() {
  return useContext(Context);
}
export function useElement() {
  return useLiveContext().element;
}
export function useError() {
  return useLiveContext().error;
}
export default function Provider(_ref7) {
  var scope = _ref7.scope,
      children = _ref7.children,
      codeText = _ref7.code,
      language = _ref7.language,
      theme = _ref7.theme,
      _ref7$showImports = _ref7.showImports,
      showImports = _ref7$showImports === void 0 ? false : _ref7$showImports,
      _ref7$renderAsCompone = _ref7.renderAsComponent,
      renderAsComponent = _ref7$renderAsCompone === void 0 ? false : _ref7$renderAsCompone,
      _ref7$resolveImports = _ref7.resolveImports,
      resolveImports = _ref7$resolveImports === void 0 ? function () {
    return Promise.resolve({});
  } : _ref7$resolveImports;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  var _useMemo = useMemo(function () {
    // Remove the prettier comments.
    var nextCode = codeText.replace(prettierComment, '').trim();
    if (showImports) return [nextCode, ''];
    var r = removeImports(nextCode);
    return [r.code, r.imports.map(function (i) {
      return i.code;
    }).join('\n').trimStart()];
  }, [codeText, showImports]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      code = _useMemo2[0],
      importBlock = _useMemo2[1];

  var handleChange = useEventCallback(function (nextCode) {
    resolveImports().then(function (importHash) {
      return codeToComponent("".concat(importBlock, "\n\n").concat(nextCode).trimStart(), _objectSpread(_objectSpread({}, scope), {}, {
        require: getRequire(importHash)
      }), renderAsComponent);
    }).then(function (c) {
      setElement(c);
      setError(null);
    }, setError);
  });
  useEffect(function () {
    handleChange(code);
  }, [code, importBlock, scope, handleChange]);
  useEffect(function () {
    handleChange(code);
  }, [code, scope, handleChange]);
  var context = useMemo(function () {
    return {
      code: code,
      error: error,
      element: element,
      language: language,
      theme: theme,
      onError: setError,
      onChange: handleChange
    };
  }, [code, element, error, handleChange, language, theme]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
}